import React, { Component } from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { AnimationStepContainer, AnimatedImage, MobileImage, Description } from './AnimationStep.style'
import { isMobile } from '../../../utils/siteHelper'

class AnimationStep extends Component {
  constructor(props) {
    super(props)
    this.onAnimationEnd = this.onAnimationEnd.bind(this)
    this.state = {
      animationOver: false,
    }
  }

  onAnimationEnd = () => {
    this.setState({
      animationOver: true,
    })
  }

  render() {
    const {
      animationImage,
      mobileImage,
      description,
    } = this.props

    const { animationOver } = this.state

    return (
      <AnimationStepContainer>
        { !isMobile() && animationImage && (
          <AnimatedImage
            src={animationImage.file.url}
            length={animationImage.file.details.image.width}
            animationOver={animationOver}
            onAnimationEnd={this.onAnimationEnd}
            className="animatedImage"
          />
        )}

        {
          isMobile() && mobileImage &&
          <MobileImage src={mobileImage.file.url} />
        }

        <Description
          dangerouslySetInnerHTML={{
            __html: description.childMarkdownRemark.html,
          }}
          className="wow fadeIn"
        />
      </AnimationStepContainer>
    )
  }
}

AnimationStep.propTypes = {
  animationImage: PropTypes.shape({
    imageFile: PropTypes.object,
  }).isRequired,
  mobileImage: PropTypes.shape({
    imageFile: PropTypes.object,
  }).isRequired,
  description: PropTypes.string.isRequired,
}

export const AnimationStepFragment = graphql`
  fragment AnimationStepFragment on ContentfulAnimationStep {
    id
    animationImage {
      file {
        url
        details {
          image {
            width
          }
        }
      }
    }
    mobileImage {
      file {
        url
      }
    }
    description {
      childMarkdownRemark {
        html
      }
    }
  }
`

export default AnimationStep
